<template>
  <div class="custom-gannt-mode">
    <template v-for="(item, index) in showImgList" :key="item.path">
      <img :src="item.path" alt="" @click="handleUpdateMode(index)" />
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";

export default defineComponent({
  setup(props, content) {
    let currentMode = 0;

    const mode = {
      0: "day",
      1: "week",
      2: "month",
    };

    const imgObject = {
      dayclick: require("@/assets/img/page/day_click.png"),
      dayunclick: require("@/assets/img/page/day_unclick.png"),
      weekclick: require("@/assets/img/page/week_click.png"),
      weekunclick: require("@/assets/img/page/week_unclick.png"),
      monthclick: require("@/assets/img/page/month_click.png"),
      monthunclick: require("@/assets/img/page/month_unclick.png"),
    };

    const showImgList = reactive([
      { path: imgObject.dayclick },
      { path: imgObject.weekunclick },
      { path: imgObject.monthunclick },
    ]);

    const handleUpdateMode = (index) => {
      currentMode = index;
      content.emit("handleUpdateMode", mode[currentMode]);
      showImgList.forEach((item, index) => {
        if (currentMode === index) {
          item.path = imgObject[`${mode[index]}click`];
        } else {
          item.path = imgObject[`${mode[index]}unclick`];
        }
      });
    };

    return {
      showImgList,
      handleUpdateMode,
    };
  },
});
</script>

<style lang="less" scoped>
.custom-gannt-mode {
  position: absolute;
  right: calc( 100vw - 1080px );
  top: 62px;
  display: flex;
  width: 80px;
  height: 20px;
  justify-content: space-between;
  img {
    width: 20px;
    height: 20px;
  }
}
</style>
